<router-outlet></router-outlet>

<app-user-cookies-consent></app-user-cookies-consent>

<!-- Added for tour components -->
<tour-step-template>
    <ng-template let-step="step">
        <div class="tour-step-container">
            <div class="tour-step-header">
                <span class="title-text">{{ step.title }}</span>
                <button mat-icon-button (click)="mdTourService.end()" color="secondary">
                    <app-mdi-icon color="secondary" name="close"></app-mdi-icon>
                </button>
            </div>
            <div class="tour-step-content" [innerHTML]="step.content"></div>
            <div class="tour-step-actions">
                @if (mdTourService.hasPrev(step)) {
                    <button id="stp-previous" mat-stroked-button color="primary" (click)="mdTourService.prev()">
                        <app-mdi-icon name="chevron-left" color="secondary"></app-mdi-icon>
                        {{ 'tour.step.back' | translate }}
                    </button>
                }
                @if (mdTourService.hasNext(step)) {
                    <button id="step-next" mat-stroked-button color="primary" (click)="mdTourService.next()">
                        {{ 'tour.step.next' | translate }}
                        <app-mdi-icon name="chevron-right" color="secondary"></app-mdi-icon>
                    </button>
                }
            </div>
        </div>
    </ng-template>
</tour-step-template>

<!-- Global loading when token changed -->
<div
    *ngIf="tokenSwapLoading()"
    class="loading-overlay"
    role="status"
    [attr.aria-label]="'auth.login.relogin.loading' | translate"
>
    <mat-progress-spinner class="spinner" diameter="100" mode="indeterminate"> </mat-progress-spinner>
</div>
